import React from 'react';
import Button from '@/components/Button';

export default function SimpleModal({ content, onClose }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4 py-8"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 md:p-8 rounded-lg shadow-2xl max-w-lg w-full max-h-[85vh] overflow-y-auto m-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-2xl font-bold mb-4 text-blue-800 text-center">{content.title}</h2>
        <p className="text-blue-700 whitespace-pre-wrap">{content.text}</p>
        <Button
          variant="default"
          className="w-full mt-6"
          onClick={onClose}
        >
          Cerrar
        </Button>
      </div>
    </div>
  );
}
